import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
export default {
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (instance) {
      return instance.$router.replace(JSON.parse(from.params.route));
    });
  },
  render: function render(h) {
    return h();
  }
};